import BaseService from "./BaseService";
import { SessionCache } from "../helpers/cache";
import { UserFavoriteInstallations } from "../core/contracts/UserFavoriteInstallations";
import { UserFavoriteInstallation } from "../core/contracts/UserFavoriteInstallation";
import User from "../core/models/User";
import FavoriteInstallation from "../core/models/FavoriteInstallation";

export default class UserFavoriteInstallationsService extends BaseService {
  async fetchFavoriteInstallations(): Promise<UserFavoriteInstallations> {
    try {
      const cache = new SessionCache();
      const cachedUser: User | null = cache.get("user");
      const response = await new BaseService(true).get<UserFavoriteInstallations>(
        `/core/UserFavoriteInstallations/GetFavoriteInstallations/${cachedUser?.id}`
      );
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetchFavoriteInstallations -> error", error);
      return Promise.reject(error);
    }
  }

  async addOrRemoveFavoriteInstallation({
    favorite,
    installationId,
  }: FavoriteInstallation): Promise<boolean> {
    try {
      const cache = new SessionCache();
      const cachedUser: User | null = cache.get("user");
      const userFavoriteInstallation: UserFavoriteInstallation = {
        installationId,
        userId: cachedUser?.id,
      };

      if (favorite) {
        return await new BaseService(true).post<boolean, UserFavoriteInstallation>(
          `/core/UserFavoriteInstallations/AddFavoriteInstallation`,
          userFavoriteInstallation
        );
      } else {
        return await new BaseService(true).delete<boolean, UserFavoriteInstallation>(
          `/core/UserFavoriteInstallations/RemoveFavoriteInstallation`,
          userFavoriteInstallation
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("UserService -> fetchFavoriteInstallations -> error", error);
      return Promise.reject(error);
    }
  }
}
